import React from 'react'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'
import { IPersonnelModel } from './PersonnelModel'

type Props = {
    data: IPersonnelModel[]
    currentPage: number
    totalPages: number
    onPageChange: (page: number) => void
    onEdit?: (personnel: IPersonnelModel) => void
    onDelete?: (personnel: IPersonnelModel) => void
    sortBy?: string
    sortOrder?: 'asc' | 'desc'
    onSort?: (column: string, order: 'asc' | 'desc') => void
    loading?: boolean
}

export const PersonnelTable: React.FC<Props> = ({
    data,
    currentPage,
    totalPages,
    onPageChange,
    onEdit,
    onDelete,
    sortBy,
    sortOrder,
    onSort,
    loading = false
}) => {
    const personnelColumns: TableColumn<IPersonnelModel>[] = [
        { key: 'firstName', label: ' Ad', className: 'fw-semibold', sortable: true },
        { key: 'lastName', label: 'Soyad' },

    ]

    const personnelActions: TableAction<IPersonnelModel>[] = [
        {
            label: 'Düzenle',
            icon: 'bi bi-pencil',
            className: 'btn-light-primary me-2',
            onClick: (personnel) => onEdit?.(personnel),
        },
        {
            label: 'Sil',
            icon: 'bi bi-trash',
            className: 'btn-light-danger',
            onClick: (personnel) => onDelete?.(personnel),
        },
    ]

    return (
        <DataTable
            data={data}
            columns={personnelColumns}
            actions={personnelActions}
            showPagination={true}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            sortBy={sortBy}
            sortOrder={sortOrder}
            onSort={onSort}
            loading={loading}
            emptyMessage='Henüz şube bulunamadı'
        />
    )
}